import { type ReactElement } from 'react'
import { PROSPECT_STAGE_COLOR } from '@terros/common'
import { getSize } from 'app/components/AvatarBlurhash'
import { type CommonIconDisplayProps } from './types'

type Props = CommonIconDisplayProps
export const ProspectStageIcon = ({ size }: Props): ReactElement => {
  const iconSize = getSize(size)
  return (
    <div
      style={{
        width: iconSize,
        height: iconSize,
        border: `4px solid ${PROSPECT_STAGE_COLOR}`,
        borderRadius: '50%',
      }}
    />
  )
}
